<template>
  <transition
    :appear="appear"
    :enter-active-class="disabled ? undefined : 'transition'"
    enter-from-class="opacity-0 translate-y-2"
    :leave-active-class="disabled ? undefined : 'transition'"
    leave-to-class="opacity-0 -translate-y-2"
    :mode="mode"
  >
    <slot />
  </transition>
</template>

<script lang="ts" setup>
import type { TransitionProps } from "vue";

defineProps<{
  appear?: boolean;
  mode?: TransitionProps["mode"];
  disabled?: boolean;
}>();
</script>
